/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { loadDeletedReportTemplates } from 'linced-app/utils/deleted-report-templates';

export default class TemplatesRoute extends Route {
  // Services
  @service
  fetch;

  @service
  permissions;

  @service
  session;

  @service
  store;

  model() {
    return hash({
      templates: this.store.findAll('reports/report-template'),
      deletedTemplates: loadDeletedReportTemplates(this),
    });
  }
}
